import { render, staticRenderFns } from "./settings-organization-api-keys.vue?vue&type=template&id=27221155&scoped=true&"
import script from "./settings-organization-api-keys.vue?vue&type=script&lang=js&"
export * from "./settings-organization-api-keys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27221155",
  null
  
)

export default component.exports